/********** ********** ********** **********
 *
 * "requiredIf":
 * to make a prop required if a condition is true or false
 *
 * from: https://github.com/jamiebuilds/react-required-if
 * COPYRIGHT (c) 2016 James Kyle <me@thejameskyle.com>
 *
 * MIT License
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * vwithout limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 ********** ********** ********** **********/
const reactRequiredIf = ({ type, condition }) => {
    return function(props, propName, componentName) {
        if (typeof type !== "function") {
            return new Error(
                "Invalid react-required-if prop type supplied to " +
                    componentName +
                    ". Validation failed."
            );
        }

        if (typeof condition !== "function") {
            return new Error(
                "Invalid react-required-if condition supplied to " +
                    componentName +
                    ". Validation failed."
            );
        }

        const test = condition(props) ? type.isRequired : type;
        return test.apply(this, arguments);
    };
};

export default reactRequiredIf;
